import type { SendMailResponse } from 'apiConnector/summary';
import type { CpSummaryMailRequest } from 'components/common-form/sidePanel/docToolbar/summary/models/cpSummaryMailRequest';
import type { LimitSummaryMailRequest } from 'components/common-form/sidePanel/docToolbar/summary/models/limitSummaryMailRequest';
import type { LiveSummaryMailRequest } from 'components/common-form/sidePanel/docToolbar/summary/models/liveSummaryMailRequest';
import type { Observable } from 'rxjs';
import type { HttpCall, IHttpClient } from 'utils/http/httpClient.model';

export interface LiveSummaryApi {
  sendMailInHtmlFormat: (request: LiveSummaryMailRequest) => Observable<HttpCall<SendMailResponse>>;
}

export interface CpSummaryApi {
  sendMailInHtmlFormat: (request: CpSummaryMailRequest) => Observable<HttpCall<SendMailResponse>>;
}

export interface LimitSummaryApi {
  sendMailInHtmlFormat: (request: LimitSummaryMailRequest) => Observable<HttpCall<SendMailResponse>>;
}

export function LiveSummaryApiConnector(http: IHttpClient): LiveSummaryApi {
  return {
    sendMailInHtmlFormat(request: LiveSummaryMailRequest): Observable<HttpCall<SendMailResponse>> {
      const url = 'api/v1/secondary-market/live-trade/send-html-mail';

      return http.postJSON<SendMailResponse>({
        url,
        body: request,
        targetHost: 'SecondaryBridge',
      });
    },
  };
}

export function CpSummaryApiConnector(http: IHttpClient): CpSummaryApi {
  return {
    sendMailInHtmlFormat(request: CpSummaryMailRequest): Observable<HttpCall<SendMailResponse>> {
      const url = 'api/v1/secondary-market/cp-order/send-html-mail';

      return http.postJSON<SendMailResponse>({
        url,
        body: request,
        targetHost: 'SecondaryBridge',
      });
    },
  };
}

export function LimitSummaryApiConnector(http: IHttpClient): LimitSummaryApi {
  return {
    sendMailInHtmlFormat(request: LimitSummaryMailRequest): Observable<HttpCall<SendMailResponse>> {
      const url = 'api/v1/secondary-market/limit-order/send-html-mail';

      return http.postJSON<SendMailResponse>({
        url,
        body: request,
        targetHost: 'SecondaryBridge',
      });
    },
  };
}
